import clsx from "clsx";

interface IProps {
  showText?: boolean;
  direction?: "row" | "column";
}

export default function Logo({ showText = true, direction = "row" }: IProps) {
  return (
    <div
      className={clsx(
        "flex items-center gap-4",
        direction === "row" ? "flex-row" : "flex-col"
      )}
    >
      <img src="/logo.svg" alt="logo" />
      {showText && (
        <div>
          <p className="font-semibold">Republic of Rwanda</p>
          <p className="text-sm text-gray-600">
            Rwanda Health Council Connect (RHCC)
          </p>
        </div>
      )}
    </div>
  );
}
